import IconTrvlClock from "@Icons/time/IconTrvlClock";
import Row from "@Containers/components/Row";
import Button from "@Generic/buttons/Button";
import Dialog from "@Features/dialog/components/Dialog";
import React, {MutableRefObject} from "react";
import Translation from "@Translation/components/Translation";

interface ExpiredSessionModalProps {
    dialogRef: MutableRefObject<HTMLDialogElement>,
    closeModal: () => void,
}
function ExpiredSessionModal({dialogRef, closeModal}: ExpiredSessionModalProps) {
    return (
        <Dialog dialogRef={dialogRef} className="check-order__error-modal expired-session">
            <h4 className="expired-session__title">
                <IconTrvlClock
                    width="24"
                    height="24"
                />
                <Translation
                    translationKey="check_order.purchase_expired_modal_title"
                />
            </h4>
            <p>
                <Translation
                    translationKey="check_order.ticket_expired_modal_message"
                />
            </p>
            <Row>
                <Button onClick={closeModal} className="green">
                    <Translation
                        translationKey="check_order.ticket_expired_button_text"
                    />
                </Button>
            </Row>
        </Dialog>
    )
}

export default ExpiredSessionModal